<mat-form-field>
    <mat-label>Country</mat-label>
    <input type="text" placeholder="Country" matInput [formControl]="countryInput" [matAutocomplete]="country">
    <mat-autocomplete #country="matAutocomplete" [displayWith]="displayFn">
        <mat-option *ngFor="let country of countries" [value]="country">{{country.toString()}}</mat-option>
    </mat-autocomplete>
</mat-form-field>